"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestStepVisibilityDtoOperatorEnum = void 0;
exports.instanceOfDigestStepVisibilityDto = instanceOfDigestStepVisibilityDto;
exports.DigestStepVisibilityDtoFromJSON = DigestStepVisibilityDtoFromJSON;
exports.DigestStepVisibilityDtoFromJSONTyped = DigestStepVisibilityDtoFromJSONTyped;
exports.DigestStepVisibilityDtoToJSON = DigestStepVisibilityDtoToJSON;
exports.DigestStepVisibilityDtoToJSONTyped = DigestStepVisibilityDtoToJSONTyped;
var DigestVisibilityConditionDto_1 = require("./DigestVisibilityConditionDto");
/**
 * @export
 */
exports.DigestStepVisibilityDtoOperatorEnum = {
    And: 'and',
    Or: 'or'
};
/**
 * Check if a given object implements the DigestStepVisibilityDto interface.
 */
function instanceOfDigestStepVisibilityDto(value) {
    if (!('operator' in value) || value['operator'] === undefined)
        return false;
    if (!('conditions' in value) || value['conditions'] === undefined)
        return false;
    return true;
}
function DigestStepVisibilityDtoFromJSON(json) {
    return DigestStepVisibilityDtoFromJSONTyped(json, false);
}
function DigestStepVisibilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'operator': json['operator'],
        'conditions': (json['conditions'].map(DigestVisibilityConditionDto_1.DigestVisibilityConditionDtoFromJSON)),
    };
}
function DigestStepVisibilityDtoToJSON(json) {
    return DigestStepVisibilityDtoToJSONTyped(json, false);
}
function DigestStepVisibilityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'operator': value['operator'],
        'conditions': (value['conditions'].map(DigestVisibilityConditionDto_1.DigestVisibilityConditionDtoToJSON)),
    };
}
